module.exports = __webpack_public_path__ + "static/media/Grid.078d6fcd.svg";